var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorIdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22222 1.77778V6.22222H5.33333V1.77778H1.77778V8.88889H5.33333V8H6.22222V12.4444H5.33333V9.77778H1.77778V14.2222H8V12.4444H8.88889V14.2222H14.2222V12.4444H16V16H0V0H16V10.6667H14.2222V6.22222H8.88889V10.6667H8V5.33333H14.2222V1.77778H6.22222Z",
    fill: "#38D68B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorIdLogo);
export default __webpack_public_path__ + "static/media/floorIdLogo.8026347d3d1017d75e0b4adc6fdbd3ae.svg";
export { ForwardRef as ReactComponent };